module.exports = "/yunkezan/static/img/entry_redpacket_bg.png";